import { render, staticRenderFns } from "./AktuelniKatalog.vue?vue&type=template&id=467f8e8e"
import script from "./AktuelniKatalog.vue?vue&type=script&lang=js"
export * from "./AktuelniKatalog.vue?vue&type=script&lang=js"
import style0 from "./AktuelniKatalog.vue?vue&type=style&index=0&id=467f8e8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports